<template>
  <v-container class="usuarios">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form>
        <PageTitle
          main="Administração"
          icon="mdi-pencil-box-outline"
          sub="Cadastro de Gerupo de menus"
          home="/administracao"
        />
        <grupo />
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Grupo from '../components/GrupoMenuAdmin.vue'
export default {
  name: 'Grupos',
  components: { PageTitle, Grupo },
  data: () => ({

  })
}
</script>
